export const paymentOptions = [
    { key: "upi", label: "UPI", description: "Pay using UPI, QR, Cards and more." },
    { key: "cod", label: "Cash On Delivery", description: "Pay on the day of delivery." }
];
